import { initializeYup } from "@duosoftbg/nacid-components";
import * as yup from "yup";

export const createAdditionalDocDetailsValidationSchemas = () => {
  initializeYup(yup);

  const additionalDocDetailsValidationSchemas = yup.object({
    entryNumber: yup.string().required(),
  });

  return additionalDocDetailsValidationSchemas;
};
